// RASTREIO RÁPIDO
// =============================================================================================
function initFastTracking() {
    
    const fastTrackingForms = document.querySelectorAll(".fast-tracking-form");
    
    if (fastTrackingForms.length) {
        
        fastTrackingForms.forEach(item => {
            
            const fastTrackingInputText = item.querySelector("input[type='text']");
            const fastTrackingImputButton = item.querySelector("button");
            const trackingSite = +item.dataset.trackingSite;
            
            fastTrackingImputButton.addEventListener("click", (event) => {
                
                const inputTextVal = fastTrackingImputButton.previousElementSibling.value.toUpperCase();
                
                if (inputTextVal !== "") {
                    if (trackingSite === 1) {
                        window.open(`https://t.17track.net/pt#nums=${inputTextVal}`, "_blank");
                    }
                    if (trackingSite === 2) {
                        window.open(`https://melhorrastreio.com.br/meu-rastreio/${inputTextVal}`, "_blank");
                    }
                } else {
                    alert("Insira o seu código de rastreio");
                }
                
            });
            
        });
        
    }
    
}
initFastTracking();



// SEÇÃO VÍDEO
// =============================================================================================
function initVideo() {
	const videos = document.querySelectorAll(".video-section__wrapper");
	if (videos.length) {
		videos.forEach(item => {
			const videoUrl = item.getAttribute('data-video-url');
			if (videoUrl) {
				const videoId = videoUrl.match("[\?&]v=([^&#]*)");
				if (videoId) {
                    const videoPlay = item.querySelector(".video-section__play-btn");
                    if (videoPlay) {
                        videoPlay.addEventListener("click", function () {
						    item.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId[1] + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
					    });
                    }
				}
			}
		});
	}
}
initVideo();



// SEÇÃO ANTES DE DEPOIS
// =============================================================================================
function initBeforeAfter() {

  var SplitCursor = class extends HTMLElement {
    _abortController;
    connectedCallback() {
      this._parentSection = this.closest(".before-after");
      this._dragging = false;
      this._offsetX = this._currentX = 0;
      this._abortController = new AbortController();
      this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this), { signal: this._abortController.signal });
      this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this), { signal: this._abortController.signal });
      this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this), { signal: this._abortController.signal });
      this.addEventListener("keydown", this._onKeyboardNavigation, { signal: this._abortController.signal });
      this._recalculateOffset();
      window.addEventListener("resize", this._recalculateOffset.bind(this), { signal: this._abortController.signal });
    }
    disconnectedCallback() {
      this._abortController?.abort();
    }
    get minOffset() {
      return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
    }
    get maxOffset() {
      return this.offsetParent.clientWidth + this.minOffset;
    }
    _onPointerDown(event) {
      if (event.target === this || this.contains(event.target)) {
        this._initialX = event.clientX - this._offsetX;
        this._dragging = true;
      }
    }
    _onPointerMove(event) {
      if (!this._dragging) {
        return;
      }
      this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
      this._offsetX = this._currentX;
      this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
    }
    _onPointerUp() {
      this._dragging = false;
    }
    _recalculateOffset() {
      this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
    }
    _onKeyboardNavigation(event) {
      if (!event.target.classList.contains("before-after__cursor") || !this.hasAttribute("vertical") && event.code !== "ArrowLeft" && event.code !== "ArrowRight" || this.hasAttribute("vertical") && event.code !== "ArrowUp" && event.code !== "ArrowDown") {
        return;
      }
      event.preventDefault();
      let currentPosition = parseInt(this._parentSection.style.getPropertyValue("--clip-path-offset"));
      let newPosition;
      if (this.hasAttribute("vertical")) {
        newPosition = event.code === "ArrowUp" ? currentPosition - 1 : currentPosition + 1;
      } else {
        newPosition = event.code === "ArrowLeft" ? currentPosition - 1 : currentPosition + 1;
      }
      this._currentX = Math.min(Math.max(newPosition, this.minOffset), this.maxOffset);
      this._offsetX = this._currentX;
      this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
    }
  };
  if (!window.customElements.get("split-cursor")) {
    window.customElements.define("split-cursor", SplitCursor);
  }
	
}
initBeforeAfter();



// SEÇÃO BANNERS DE VANTAGENS
// =============================================================================================
function initAdvantagesBanner() {
    const AdvantagesBanner = document.querySelectorAll(".text-with-icons");
    if (AdvantagesBanner) {
        AdvantagesBanner.forEach(item => {
            const breakpoint = window.matchMedia('(min-width: 992px)');
            let swiperAdvantagesBanner;
            const breakpointChecker = function() {
                if (breakpoint.matches === true) {
                    if (swiperAdvantagesBanner !== undefined) swiperAdvantagesBanner.destroy(true, true);
                    return;
                } else if (breakpoint.matches === false) {
                    return enableSwiper();
                }
            };

            function enableSwiper() {
                swiperAdvantagesBanner = new Swiper(item.querySelector(".swiper"), {
                    slidesPerView: 1,
                    spaceBetween: 21,
                    loop: false,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2
                        }
                    },
                    navigation: {
                        nextEl: item.querySelector(".swiper-button-next"),
                        prevEl: item.querySelector(".swiper-button-prev"),
                    },
                    on: {
                        init: function() {
                            function checkNavigationActive() {
                                if (!item.querySelector(".swiper-button-lock")) {
                                    item.querySelector(".text-with-icons__navigation-wrapper").classList.add("text-with-icons__navigation-wrapper--nav-active")
                                } else {
                                    item.querySelector(".text-with-icons__navigation-wrapper").classList.remove("text-with-icons__navigation-wrapper--nav-active")
                                }
                            }
                            checkNavigationActive()
                            window.addEventListener("resize", checkNavigationActive)
                        }
                    }
                });
            }
            breakpoint.addListener(breakpointChecker);
            breakpointChecker();
        });
    }
}
initAdvantagesBanner();



// SEÇÃO DEPOIMENTOS
// =============================================================================================
function initCustomerTestimonials() {
    const testimonials = document.querySelectorAll(".testimonials-section");
    if (testimonials.length) {
        testimonials.forEach(item => {

            function testimonialsSlideFormat() {
                const swiperTestimonial = new Swiper(item.querySelector(".swiper"), {
                    slidesPerView: 1.3,
                    spaceBetween: 20,
                    lazy: true,
                    preloadImages: false,
                    watchSlidesProgress: true,
                    centerInsufficientSlides: true,
                    navigation: {
                        nextEl: item.querySelector(".swiper-button-next"),
                        prevEl: item.querySelector(".swiper-button-prev"),
                    },
                    pagination: {
                        el: item.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 0,
                        }
                    },
                    on: {
                        init: function() {
                            function checkNavigationActive() {
                                if (!item.querySelector(".swiper-button-lock")) {
                                    item.querySelector(".testimonials-section__wrapper").classList.add("testimonials-section__wrapper--nav-active")
                                } else {
                                    item.querySelector(".testimonials-section__wrapper").classList.remove("testimonials-section__wrapper--nav-active")
                                }
                            }
                            checkNavigationActive()
                            window.addEventListener("resize", checkNavigationActive)
                        },
                    }
                });
            }
            testimonialsSlideFormat();
        });
    }
}
initCustomerTestimonials();



// SEÇÃO SLIDESHOW
// =============================================================================================
function initSlideshow() {
    const slideshow = document.querySelectorAll(".slideshow")

    if (slideshow.length) {

        slideshow.forEach(item => {

            const itemsLength = item.querySelectorAll(".slideshow__item")

            function sliderFormat() {
                const swiperSlideshow = new Swiper(item.querySelector(".swiper"), {
                    slidesPerView: 1,
                    effect: "fade",
                    speed: 800,
                    loop: (itemsLength.length > 1) ? true : false,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    navigation: {
                        nextEl: item.querySelector(".swiper-button-next"),
                        prevEl: item.querySelector(".swiper-button-prev"),
                    },
                    pagination: {
                        el: item.querySelector(".swiper-pagination"),
                        clickable: true,
                    }
                });
            }
            sliderFormat()

        });

    }
}
initSlideshow();



// SEÇÃO LISTA DE LOGOS
// =============================================================================================
function initLogoList() {
    const logoList = document.querySelectorAll(".logo-list");
    if (logoList.length) {
        logoList.forEach(item => {

            function logoListCarroussel() {
                const swiper = new Swiper(item.querySelector(".swiper"), {
                    slidesPerView: 2,
                    loop: false,
                    spaceBetween: 21,
                    navigation: {
                        nextEl: item.querySelector(".swiper-button-next"),
                        prevEl: item.querySelector(".swiper-button-prev"),
                    },
                    pagination: {
                        el: item.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 4
                        },
                        1024: {
                            slidesPerView: 6
                        }
                    },
                    on: {
                        init: function() {
                            function checkNavigationActive() {
                                if (!item.querySelector(".swiper-button-lock")) {
                                    item.querySelector(".logo-list__wrapper").classList.add("logo-list__wrapper--nav-active")
                                } else {
                                    item.querySelector(".logo-list__wrapper").classList.remove("logo-list__wrapper--nav-active")
                                }
                            }
                            checkNavigationActive()
                            window.addEventListener("resize", checkNavigationActive)
                        }
                    }
                });
            }
            logoListCarroussel()
        });
    }
}
initLogoList()



// SEÇÃO IMAGENS DO INSTAGRAM
// =============================================================================================
function initInstaCarousel() {

    const instaImgsSec = document.querySelectorAll(".instagram-gallery")

    if (instaImgsSec.length) {

        instaImgsSec.forEach(item => {

            const swiper = new Swiper(item.querySelector(".swiper"), {
                slidesPerView: 2,
                spaceBetween: 20,
                watchSlidesProgress: true,
                centerInsufficientSlides: true,
                lazy: true,
                preloadImages: false,
                navigation: {
                    nextEl: item.querySelector(".swiper-button-next"),
                    prevEl: item.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: item.querySelector(".swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 5,
                    }
                },
                on: {
                    init: function() {
                        function checkNavigationActive() {
                            if (!item.querySelector(".swiper-button-lock")) {
                                item.querySelector(".instagram-gallery__wrapper").classList.add("instagram-gallery__wrapper--nav-active")
                            } else {
                                item.querySelector(".instagram-gallery__wrapper").classList.remove("instagram-gallery__wrapper--nav-active")
                            }
                        }
                        checkNavigationActive()
                        window.addEventListener("resize", checkNavigationActive)
                    },
                }

            })

        })

    }
}
initInstaCarousel()



// SEÇÃO GALERIA DE IMAGENS
// =============================================================================================
function initImageGalleryCarousel() {

    const imageGallery = document.querySelectorAll(".image-gallery")

    if (imageGallery.length) {

        imageGallery.forEach(item => {

            const imageGalleryItems = item.querySelectorAll(".image-gallery__item")

            const breakpoint = window.matchMedia('(min-width: 768px)');
            let swiperMiniBanners;
            const breakpointChecker = function() {
                if (breakpoint.matches === true) {
                    if (swiperMiniBanners !== undefined) swiperMiniBanners.destroy(true, true);
                    return;
                } else if (breakpoint.matches === false) {
                    return enableSwiper()
                }
            };

            function enableSwiper() {
                swiperMiniBanners = new Swiper(item.querySelector(".swiper"), {
                    slidesPerView: imageGalleryItems.length > 1 ? 1.3 : 1,
                    spaceBetween: 20,
                    watchSlidesProgress: true,
                    centerInsufficientSlides: true,
                    lazy: true,
                    loop: false,
                });
            }

            breakpointChecker()
            try {
                breakpoint.addEventListener("change", breakpointChecker);
            } catch (e) {
                breakpoint.addListener(breakpointChecker);
            }

        })

    }

}
initImageGalleryCarousel()



// SEÇÃO CARROSSEL DE PRODUTOS EM DESTAQUE
// =============================================================================================
function initProductsCarroussel() {
    const productsCarroussel = document.querySelectorAll(".featured-collection.carousel-enabled");
    if (productsCarroussel.length) {
        productsCarroussel.forEach(item => {
            function productsCarrousselSlideFormat() {

                const productPerRowMobile = item.getAttribute("data-products-per-row-mobile")

                const swiperProductsCarroussel = new Swiper(item.querySelector(".swiper"), {
                    slidesPerView: productPerRowMobile,
                    spaceBetween: 10,
                    watchSlidesProgress: true,
                    centerInsufficientSlides: true,
                    navigation: {
                        nextEl: item.querySelector(".swiper-button-next"),
                        prevEl: item.querySelector(".swiper-button-prev")
                    },
                    pagination: {
                        el: item.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                    breakpoints: {
                        460: {
                            slidesPerView: productPerRowMobile == 1.3 ? 2.3 : productPerRowMobile == 1 ? 2 : 2,
                        },
                        540: {
                            slidesPerView: 3,
                            spaceBetween: 21,
                        },
                        1024: {
                            slidesPerView: 4
                        }
                    },
                    on: {
                        init: function() {
                            function checkNavigationActive() {
                                if (!item.querySelector(".swiper-button-lock")) {
                                    item.querySelector(".featured-collection__wrapper").classList.add("featured-collection__wrapper--nav-active")
                                } else {
                                    item.querySelector(".featured-collection__wrapper").classList.remove("featured-collection__wrapper--nav-active")
                                }
                            }
                            checkNavigationActive()
                            window.addEventListener("resize", checkNavigationActive)
                        },
                    }
                });
            }
            productsCarrousselSlideFormat();
        });
    }
}
initProductsCarroussel();



// SEÇÃO CARROSSEL DE POSTAGENS DO BLOG
// =============================================================================================
function initBlogPostsCarousel() {
  
  const blog = document.querySelectorAll(".blog")
  
  if (blog.length) {

    blog.forEach(item => {

      const swiper = new Swiper(item.querySelector(".swiper"), {
          slidesPerView: 2,
          spaceBetween: 30,
          lazy: true,
          preloadImages: false,
          watchSlidesProgress: true,
          centerInsufficientSlides: true,
          navigation: {
              nextEl: item.parentElement.querySelector(".swiper-button-next"),
              prevEl: item.parentElement.querySelector(".swiper-button-prev"),
          },
          pagination: {
              el: item.querySelector(".swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
              460: {
                  slidesPerView: 3,
              },
              992: {
                  slidesPerView: 4,
              },
          },
          on: {
            init: function() {
                function checkNavigationActive() {
                    if (!item.querySelector(".swiper-button-lock")) {
                        item.querySelector(".blog__wrapper").classList.add("blog__wrapper--nav-active")
                    } else {
                        item.querySelector(".blog__wrapper").classList.add("blog__wrapper--nav-active")
                    }
                }
                checkNavigationActive()
                window.addEventListener("resize", checkNavigationActive)
            }
          }
        })

      });
  }
}
initBlogPostsCarousel()



// SEÇÃO CARROSSEL DE COLEÇÕES EM DESTAQUE
// =============================================================================================
function initCollectionListCarousel() {

    const collectionList = document.querySelectorAll(".collection-list")

    if (collectionList.length) {

        collectionList.forEach(item => {

            const swiper = new Swiper(item.querySelector(".swiper"), {
                slidesPerView: 2.3,
                spaceBetween: 30,
                lazy: true,
                preloadImages: false,
                watchSlidesProgress: true,
                centerInsufficientSlides: true,
                navigation: {
                    nextEl: item.querySelector(".swiper-button-next"),
                    prevEl: item.querySelector(".swiper-button-prev"),
                },
                pagination: {
                    el: item.querySelector(".swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    460: {
                        slidesPerView: 3.3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    992: {
                        slidesPerView: 7,
                    },
                },
                on: {
                    init: function() {
                        function checkNavigationActive() {
                            if (!item.querySelector(".swiper-button-lock")) {
                                item.querySelector(".collection-list__wrapper").classList.add("collection-list__wrapper--nav-active")
                            } else {
                                item.querySelector(".collection-list__wrapper").classList.remove("collection-list__wrapper--nav-active")
                            }
                        }
                        checkNavigationActive()
                        window.addEventListener("resize", checkNavigationActive)
                    },
                }

            })

        })

    }

}
initCollectionListCarousel()



// SEÇÃO FILTROS DA HOME
// =============================================================================================
function initHomeFiltersTabs() {
    document.querySelectorAll('.filter-home').forEach(container => {
        const tabButtons = container.querySelectorAll('.filter-home__button');
        const tabContents = container.querySelectorAll('.filter-home__tab-content');

        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                tabContents.forEach(content => content.style.display = 'none');
                tabButtons.forEach(btn => btn.classList.remove('active'));
                
                const tabId = button.getAttribute('data-tab');
                container.querySelector(`#${tabId}`).style.display = 'block';
                button.classList.add('active');
            });
        });

        if (tabButtons.length > 0 && tabContents.length > 0) {
            tabButtons[0].classList.add('active');
            tabContents[0].style.display = 'block';
        }
    });
}
initHomeFiltersTabs();

if (!customElements.get('filter-home')) {
  customElements.define(
    'filter-home',

    class FilterHome extends HTMLElement {
      constructor() {
          super(),
          this.elements = {
              filterDetails: this.querySelectorAll("details"),
              filterSummary: this.querySelectorAll("summary"),
              filterItems: this.querySelectorAll(".filter-select__item:not(.holder)"),
              filterSubmitButton: this.querySelector(".filter-home__btn")
          },
          this.elements.filterSubmitButton.hasAttribute("data-previous-href") || this.elements.filterSubmitButton.setAttribute("data-previous-href", this.elements.filterSubmitButton.getAttribute("href")),
          this.previousHref = this.elements.filterSubmitButton.getAttribute("data-previous-href"),
          this.elements.filterDetails.forEach(item => {
              item.addEventListener("click", this.closeDetails.bind(this, item));
              const summary = item.querySelector("summary");
              summary && (summary.setAttribute("tabindex", "0"),
              summary.addEventListener("keydown", this.handleKeyDown.bind(this, item)),
              item.addEventListener("focusout", this.handleFocusOut.bind(this, item)))
          }
          ),
          document.addEventListener("click", this.closeAllDetails.bind(this)),
          this.elements.filterItems.forEach(item => {
              item.addEventListener("click", this.onClick.bind(this, item)),
              item.setAttribute("tabindex", "0"),
              item.addEventListener("keydown", this.handleItemKeyDown.bind(this, item))
          }
          )
        
      }

      handleKeyDown(details, event) {
          (event.key === "Enter" || event.key === " ") && (event.preventDefault(),
          details.open = !details.open)
      }
      handleItemKeyDown(item, event) {
          (event.key === "Enter" || event.key === " ") && (event.preventDefault(),
          this.onClick(item))
      }
      closeDetails(clickedItem) {
          this.elements.filterDetails.forEach(item => {
              item !== clickedItem && item.removeAttribute("open")
          }
          )
      }
      closeAllDetails(event) {
          Array.from(this.elements.filterDetails).some(item => item.contains(event.target)) || this.elements.filterDetails.forEach(item => {
              item.removeAttribute("open")
          }
          )
      }
      handleFocusOut(details, event) {
          setTimeout( () => {
              details.contains(document.activeElement) || details.removeAttribute("open")
          }
          , 0)
      }
      onClick(clickedItem) {
          const parentDetails = clickedItem.closest("details")
            , summaryElement = parentDetails.querySelector("summary span");
          summaryElement && (summaryElement.textContent = clickedItem.textContent),
          clickedItem.classList.toggle("active"),
          parentDetails.querySelectorAll(".filter-select__item:not(.holder)").forEach(item => {
              item !== clickedItem && item.classList.remove("active")
          }
          ),
          parentDetails.removeAttribute("open"),
          this.updateFilters()
      }
      
      updateFilters() {
          const activeItems = this.querySelectorAll(".filter-select__item.active:not(.holder)")
            , dataFilterValues = Array.from(activeItems).map(item => item.getAttribute("data-filter")).join("&")
            , currentValue = this.previousHref || "";
          fetch(`${currentValue}?${dataFilterValues}`).then(response => response.text()).then(responseText => {
              const html = responseText
                , parsedHTML = new DOMParser().parseFromString(html, "text/html");
              console.log("parsedHTML", parsedHTML);
              const disabledElements = parsedHTML.querySelectorAll("facet-filters-form .list-menu__item input[disabled]");
              this.elements.filterItems.forEach(filterItem => {
                  const filterItemValue = filterItem.getAttribute("data-filter");
                  filterItem.classList.remove("disabled"),
                  filterItem.removeAttribute("disabled"),
                  disabledElements.forEach(disabledElement => {
                      const disabledValues = disabledElement.getAttribute("data-filter");
                      filterItemValue === disabledValues && (filterItem.classList.add("disabled"),
                      filterItem.setAttribute("disabled", ""),
                      filterItem.setAttribute("tabindex", "-1"))
                  }
                  )
              }
              )
          }
          ),
          this.elements.filterSubmitButton.setAttribute("href", `${currentValue}?${dataFilterValues}`),
          this.elements.filterSubmitButton.removeAttribute("aria-disabled")
      }
  }
    
  );
}



/* MENU MOBILE */
function initMenuMobile() {
	
  const iconOpenMenu = document.querySelectorAll(".header__nav-mobile .header__nav-item > .header__nav-icon");
  iconOpenMenu.forEach(item => {
      item.addEventListener("click", function (event) {
          event.preventDefault();
          item.parentElement.classList.toggle("active");
      });
  });
  const iconCloseMenu = document.querySelectorAll(".header__subnav-back-button");
  iconCloseMenu.forEach(item => {
      item.addEventListener("click", function () {
          item.parentElement.parentElement.previousElementSibling.classList.remove("active");
      });
  });
  const submenuHeadings = document.querySelectorAll(".header__subnav-heading");
  submenuHeadings.forEach(item => {
      const seeAllLi = document.createElement("li");
      const seeAllAnchor = document.createElement("a");
      const categUrl = item.parentElement.previousElementSibling.getAttribute("href");
      const categText = item.parentElement.previousElementSibling.getAttribute("data-js");
      seeAllAnchor.classList.add("header__nav-see-all");
      seeAllAnchor.setAttribute("href", categUrl);
      seeAllAnchor.innerText = categText;
      seeAllLi.appendChild(seeAllAnchor);
      item.after(seeAllLi);
      item.parentElement.previousElementSibling.removeAttribute("data-js");
  });
	
}
initMenuMobile();



/* MENU LATERAL */
function initSidebarMenu() {
	const sidebarMenu = document.querySelector(".sidebar__menu");
	if (sidebarMenu) {
		const sidebarMenuHeading = sidebarMenu.querySelector(".sidebar__menu-heading");
		sidebarMenuHeading.addEventListener("click", function () {
			this.classList.toggle("sidebar__menu-heading--active");
		});
	}
}
initSidebarMenu();



/* CARRINHO DE COMPRAS MOBILE */
document.querySelector(".mobile-over").addEventListener("click", (event) => {
	event.preventDefault();
});


/* AVALIAÇÕES NA LISTAGEM DE PRODUTOS */
function initproducGridratings() {
	const producGridratings = document.querySelectorAll(".product-grid .ratings");
	if (producGridratings) {
		producGridratings.forEach(item => {
			item.parentElement.querySelector(".card-information").before(item);
			item.classList.remove("d-none");
		});
	}
}
initproducGridratings();



/* AUTENTICAÇÃO DO TEMA */
function txtByTpwr() {
	const a = document.documentElement.getAttribute("data-id");
	const b = document.documentElement.getAttribute("data");
	const c = parseInt(b, 16);
	const d = "VXRpbGl6ZSBhIHN1YSBjaGF2ZSBkZSBsaWNlbudhIHBhcmEgYXRpdmFyIG8gdGVtYQ==";
	const e = "dW5hdXRoZW50aWNhdGVkLXRoZW1l";
	const f = "YXV0aGVudGljYXRlZC10aGVtZQ==";
	if (!a || !b || c != a) {
		document.documentElement.classList.add(atob(e));
		document.body.innerHTML = `<span>${atob(d)}</span>`;
	} else {
		document.documentElement.classList.add(atob(f));
	}
}

if (!Shopify.designMode) {
	txtByTpwr();
}



/* TABELA DE PARCELAMENTO */
function installmentTable() {


	const installmentTable = document.querySelector("#installment-table");


	if (installmentTable) {


		const installments = installmentTable.querySelectorAll("#installment-table .installment");
		let productPrice = document.querySelector(".product__info-container .price-item--last").innerHTML;
		productPrice = productPrice.replace("R$", "").replace("BRL", "").replace(".", "").replace(",", ".");
		productPrice = Number(productPrice);


		installments.forEach((item) => {

			// 1x
			if (item.classList.contains("1x")) {
				const interestFreeText1x = interestFreeInstallments <= 1 ? "" : " sem juros";
				item.innerHTML = (productPrice / 1).toFixed(2).replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + interestFreeText1x;
			}


			// 2x
			if (item.classList.contains("2x") && maximumInstallments >= 2) {

				const interestFreeProductValue2x = (productPrice / 2).toFixed(2);
				const productValueWithInterest2x = (installmentInterest2x * productPrice).toFixed(2);


				if (interestFreeInstallments >= 2 && interestFreeProductValue2x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue2x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");
					installmentTable.classList.remove("hide");
					installmentTable.querySelector("li:first-child").classList.remove("hide");


				} else if (productValueWithInterest2x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest2x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					installmentTable.classList.remove("hide");
					installmentTable.querySelector("li:first-child").classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
					installmentTable.classList.add("hide");
				}
			}


			// 3x
			if (item.classList.contains("3x") && maximumInstallments >= 3) {

				const interestFreeProductValue3x = (productPrice / 3).toFixed(2);
				const productValueWithInterest3x = (installmentInterest3x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 3 && interestFreeProductValue3x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue3x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest3x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest3x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 4x
			if (item.classList.contains("4x") && maximumInstallments >= 4) {

				const interestFreeProductValue4x = (productPrice / 4).toFixed(2);
				const productValueWithInterest4x = (installmentInterest4x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 4 && interestFreeProductValue4x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue4x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest4x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest4x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 5x
			if (item.classList.contains("5x") && maximumInstallments >= 5) {

				const interestFreeProductValue5x = (productPrice / 5).toFixed(2);
				const productValueWithInterest5x = (installmentInterest5x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 5 && interestFreeProductValue5x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue5x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest5x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest5x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 6x
			if (item.classList.contains("6x") && maximumInstallments >= 6) {

				const interestFreeProductValue6x = (productPrice / 6).toFixed(2);
				const productValueWithInterest6x = (installmentInterest6x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 6 && interestFreeProductValue6x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue6x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest6x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest6x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 7x
			if (item.classList.contains("7x") && maximumInstallments >= 7) {

				const interestFreeProductValue7x = (productPrice / 7).toFixed(2);
				const productValueWithInterest7x = (installmentInterest7x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 7 && interestFreeProductValue7x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue7x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest7x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest7x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 8x
			if (item.classList.contains("8x") && maximumInstallments >= 8) {

				const interestFreeProductValue8x = (productPrice / 8).toFixed(2);
				const productValueWithInterest8x = (installmentInterest8x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 8 && interestFreeProductValue8x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue8x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest8x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest8x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 9x
			if (item.classList.contains("9x") && maximumInstallments >= 9) {

				const interestFreeProductValue9x = (productPrice / 9).toFixed(2);
				const productValueWithInterest9x = (installmentInterest9x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 9 && interestFreeProductValue9x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue9x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest9x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest9x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 10x
			if (item.classList.contains("10x") && maximumInstallments >= 10) {

				const interestFreeProductValue10x = (productPrice / 10).toFixed(2);
				const productValueWithInterest10x = (installmentInterest10x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 10 && interestFreeProductValue10x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue10x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest10x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest10x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 11x
			if (item.classList.contains("11x") && maximumInstallments >= 11) {

				const interestFreeProductValue11x = (productPrice / 11).toFixed(2);
				const productValueWithInterest11x = (installmentInterest11x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 11 && interestFreeProductValue11x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue11x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest11x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest11x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}


			// 12x
			if (item.classList.contains("12x") && maximumInstallments >= 12) {

				const interestFreeProductValue12x = (productPrice / 12).toFixed(2);
				const productValueWithInterest12x = (installmentInterest12x * productPrice).toFixed(2);

				if (interestFreeInstallments >= 12 && interestFreeProductValue12x >= minimumInstallmentAmount) {

					item.innerHTML = interestFreeProductValue12x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.") + " sem juros";
					item.parentNode.parentNode.classList.remove("hide");

				} else if (productValueWithInterest12x >= minimumInstallmentAmount) {

					item.innerHTML = productValueWithInterest12x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.");
					item.parentNode.parentNode.classList.remove("hide");
					item.parentNode.parentNode.classList.add("with-interest");

				} else {
					item.parentNode.parentNode.classList.add("hide");
				}

			}

		});

	}


}
installmentTable();



/* PARCELAMENTO PÁGINA DO PRODUTO */
function productInstallment() {


	const installments = document.querySelector(".product__info-container .price__container .installments");
	const productPrice = document.querySelectorAll(".product__info-container .price-item--last");


	if (installments) {

		productPrice.forEach((item) => {

			let productPriceItem = item.innerHTML;
			productPriceItem = productPriceItem.replace("R$", "").replace("BRL", "").replace(".", "").replace(",", ".");
			productPriceItem = Number(productPriceItem);


			// 2x   
			if (maximumInstallments >= 2) {
				const interestFreeProductValue2x = (productPriceItem / 2).toFixed(2);
				const productValueWithInterest2x = (installmentInterest2x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 2 && interestFreeProductValue2x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue2x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "2x";
					item.parentElement.nextElementSibling.classList.remove("hide");
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest2x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest2x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "2x";
					item.parentElement.nextElementSibling.classList.remove("hide");
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 3x   
			if (maximumInstallments >= 3) {
				const interestFreeProductValue3x = (productPriceItem / 3).toFixed(2);
				const productValueWithInterest3x = (installmentInterest3x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 3 && interestFreeProductValue3x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue3x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "3x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest3x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest3x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "3x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 4x   
			if (maximumInstallments >= 4) {
				const interestFreeProductValue4x = (productPriceItem / 4).toFixed(2);
				const productValueWithInterest4x = (installmentInterest4x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 4 && interestFreeProductValue4x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue4x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "4x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest4x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest4x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "4x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 5x   
			if (maximumInstallments >= 5) {
				const interestFreeProductValue5x = (productPriceItem / 5).toFixed(2);
				const productValueWithInterest5x = (installmentInterest5x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 5 && interestFreeProductValue5x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue5x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "5x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest5x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest5x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "5x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 6x   
			if (maximumInstallments >= 6) {
				const interestFreeProductValue6x = (productPriceItem / 6).toFixed(2);
				const productValueWithInterest6x = (installmentInterest6x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 6 && interestFreeProductValue6x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue6x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "6x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest6x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest6x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "6x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 7x   
			if (maximumInstallments >= 7) {
				const interestFreeProductValue7x = (productPriceItem / 7).toFixed(2);
				const productValueWithInterest7x = (installmentInterest7x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 7 && interestFreeProductValue7x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue7x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "7x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest7x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest7x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "7x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 8x   
			if (maximumInstallments >= 8) {
				const interestFreeProductValue8x = (productPriceItem / 8).toFixed(2);
				const productValueWithInterest8x = (installmentInterest8x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 8 && interestFreeProductValue8x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue8x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "8x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest8x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest8x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "8x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 9x   
			if (maximumInstallments >= 9) {
				const interestFreeProductValue9x = (productPriceItem / 9).toFixed(2);
				const productValueWithInterest9x = (installmentInterest9x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 9 && interestFreeProductValue9x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue9x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "9x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest9x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest9x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "9x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 10x   
			if (maximumInstallments >= 10) {
				const interestFreeProductValue10x = (productPriceItem / 10).toFixed(2);
				const productValueWithInterest10x = (installmentInterest10x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 10 && interestFreeProductValue10x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue10x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "10x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest10x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest10x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "10x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 11x   
			if (maximumInstallments >= 11) {
				const interestFreeProductValue11x = (productPriceItem / 11).toFixed(2);
				const productValueWithInterest11x = (installmentInterest11x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 11 && interestFreeProductValue11x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue11x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "11x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest11x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest11x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "11x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 12x   
			if (maximumInstallments >= 12) {
				const interestFreeProductValue12x = (productPriceItem / 12).toFixed(2);
				const productValueWithInterest12x = (installmentInterest12x * productPriceItem).toFixed(2);


				if (interestFreeInstallments == 12 && interestFreeProductValue12x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue12x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "12x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest12x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest12x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "12x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}


		});


	}
}
productInstallment();



/* PARCELAMENTO LISTAGEM DE PRODUTOS */
function installmentProductList() {


	const installments = document.querySelector(".product-grid .grid__item .installments");
	const productPrice = document.querySelectorAll(".product-grid .price__sale .price-item--last");


	if (installments) {

		productPrice.forEach((item) => {


			let productPriceItem = item.innerHTML;
			productPriceItem = productPriceItem.replace("R$", "").replace("BRL", "").replace(".", "").replace(",", ".");
			productPriceItem = Number(productPriceItem);


			// 2x   
			if (maximumInstallments >= 2) {
				const interestFreeProductValue2x = (productPriceItem / 2).toFixed(2);
				const productValueWithInterest2x = (installmentInterest2x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 2 && interestFreeProductValue2x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue2x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "2x";
					item.parentElement.nextElementSibling.classList.remove("hide");
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest2x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest2x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "2x";
					item.parentElement.nextElementSibling.classList.remove("hide");
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 3x   
			if (maximumInstallments >= 3) {
				const interestFreeProductValue3x = (productPriceItem / 3).toFixed(2);
				const productValueWithInterest3x = (installmentInterest3x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 3 && interestFreeProductValue3x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue3x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "3x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest3x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest3x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "3x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 4x   
			if (maximumInstallments >= 4) {
				const interestFreeProductValue4x = (productPriceItem / 4).toFixed(2);
				const productValueWithInterest4x = (installmentInterest4x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 4 && interestFreeProductValue4x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue4x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "4x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest4x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest4x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "4x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 5x   
			if (maximumInstallments >= 5) {
				const interestFreeProductValue5x = (productPriceItem / 5).toFixed(2);
				const productValueWithInterest5x = (installmentInterest5x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 5 && interestFreeProductValue5x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue5x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "5x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest5x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest5x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "5x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 6x   
			if (maximumInstallments >= 6) {
				const interestFreeProductValue6x = (productPriceItem / 6).toFixed(2);
				const productValueWithInterest6x = (installmentInterest6x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 6 && interestFreeProductValue6x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue6x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "6x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest6x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest6x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "6x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 7x   
			if (maximumInstallments >= 7) {
				const interestFreeProductValue7x = (productPriceItem / 7).toFixed(2);
				const productValueWithInterest7x = (installmentInterest7x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 7 && interestFreeProductValue7x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue7x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "7x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest7x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest7x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "7x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 8x   
			if (maximumInstallments >= 8) {
				const interestFreeProductValue8x = (productPriceItem / 8).toFixed(2);
				const productValueWithInterest8x = (installmentInterest8x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 8 && interestFreeProductValue8x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue8x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "8x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest8x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest8x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "8x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 9x   
			if (maximumInstallments >= 9) {
				const interestFreeProductValue9x = (productPriceItem / 9).toFixed(2);
				const productValueWithInterest9x = (installmentInterest9x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 9 && interestFreeProductValue9x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue9x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "9x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest9x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest9x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "9x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 10x   
			if (maximumInstallments >= 10) {
				const interestFreeProductValue10x = (productPriceItem / 10).toFixed(2);
				const productValueWithInterest10x = (installmentInterest10x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 10 && interestFreeProductValue10x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue10x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "10x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest10x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest10x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "10x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 11x   
			if (maximumInstallments >= 11) {
				const interestFreeProductValue11x = (productPriceItem / 11).toFixed(2);
				const productValueWithInterest11x = (installmentInterest11x * productPriceItem).toFixed(2);


				if (interestFreeInstallments >= 11 && interestFreeProductValue11x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue11x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "11x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest11x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest11x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "11x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}

			// 12x   
			if (maximumInstallments >= 12) {
				const interestFreeProductValue12x = (productPriceItem / 12).toFixed(2);
				const productValueWithInterest12x = (installmentInterest12x * productPriceItem).toFixed(2);


				if (interestFreeInstallments == 12 && interestFreeProductValue12x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${interestFreeProductValue12x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "12x";
					item.parentElement.nextElementSibling.classList.add("interest-free");
					item.parentElement.nextElementSibling.classList.remove("with-interest");
				} else if (productValueWithInterest12x >= minimumInstallmentAmount) {
					item.parentElement.nextElementSibling.querySelector(".installment").innerHTML = `<span>${productValueWithInterest12x.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}</span>`;
					item.parentElement.nextElementSibling.querySelector(".times").innerHTML = "12x";
					item.parentElement.nextElementSibling.classList.add("with-interest");
					item.parentElement.nextElementSibling.classList.remove("interest-free");
				}

			}


		});


	}
}
installmentProductList();



/* DESCONTO À VISTA PÁGINA DO PRODUTO */
function discountPriceProduct() {

	const cashDiscountEl = document.querySelector(".product__info-container .price__container .cash-discount");
	const productPriceWithoutDiscount = document.querySelectorAll(".product__info-container .price__sale .price-item--last");

	if (cashDiscountEl) {

		productPriceWithoutDiscount.forEach((item) => {

			let productPriceItem = item.innerHTML;
			productPriceItem = productPriceItem.replace("R$", "").replace("BRL", "").replace(".", "").replace(",", ".");
			productPriceItem = Number(productPriceItem);

			const descVal = (cashDiscount / 100 * productPriceItem);

			const productPriceWithDiscount = (productPriceItem - descVal).toFixed(2);

			item.parentElement.parentElement.querySelector(".discount-price").innerHTML = `R$ ${productPriceWithDiscount.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}`;
			item.parentElement.parentElement.querySelector(".cash-discount").classList.remove("hide");

		});

	}

}
discountPriceProduct();



/* DESCONTO À VISTA LISTAGEM DE PRODUTOS */
function discountPriceProductList() {

	const cashDiscountEl = document.querySelector(".product-grid .grid__item .cash-discount");
	const productPriceWithoutDiscount = document.querySelectorAll(".product-grid .price__sale .price-item--last");

	if (cashDiscountEl) {

		productPriceWithoutDiscount.forEach((item) => {

			let productPriceItem = item.innerHTML;
			productPriceItem = productPriceItem.replace("R$", "").replace("BRL", "").replace(".", "").replace(",", ".");
			productPriceItem = Number(productPriceItem);

			const descVal = (cashDiscount / 100 * productPriceItem);
			const productPriceWithDiscount = (productPriceItem - descVal).toFixed(2);

			item.parentElement.parentElement.querySelector(".discount-price").innerHTML = `R$ ${productPriceWithDiscount.replace(".", ",").replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&.")}`;
			item.parentElement.parentElement.querySelector(".cash-discount").classList.remove("hide");

		});

	}

}
discountPriceProductList();



/* SELO PORCENTAGEM PRODUTO EM PROMOÇÃO - PÁGINA DO PRODUTO */
function productSalePercentage() {

    const productInfoContainer = document.querySelectorAll(".product__info-container")

    if (productInfoContainer.length) {

        productInfoContainer.forEach((item) => {

            const saleBadge = item.querySelector(".product__info-container .price__badge-sale")

            if (saleBadge) {
	  
                const regularPriceCheck = item.querySelector(".product__info-container .price__sale .price-item--regular");
            
                if(regularPriceCheck){
                
                    let initialPrice = regularPriceCheck.innerHTML;

                    if(initialPrice.trim().length !== 0){

                        initialPrice = initialPrice.replace(/\D/g, "")
                        initialPrice = Number(initialPrice);
                    
                        let finalPrice = item.querySelector(".product__info-container .price__sale .price-item--last").innerHTML;
                    
                        finalPrice = finalPrice.replace(/\D/g, "")
                        finalPrice = Number(finalPrice);
                    
                        const salePercentage = Math.round((initialPrice - finalPrice) * (100 / initialPrice));
                        
                        if (typeof salePercentageTextBegin === 'undefined') {
                            const salePercentageTextBegin = "-";
                            saleBadge.innerHTML = `${salePercentageTextBegin}${salePercentage}%`;
                        } else {
                            saleBadge.innerHTML = `${salePercentageTextBegin}${salePercentage}%`;
                        }				
                    }

                }
                
	        }

		});

    }

}
productSalePercentage();



/* SLIDETOGGLE TABELA DE PARCELAMENTO */
function slideToggleInstallmentTable(){
	const installmentTableHeading = document.querySelector("#installment-table .heading");
	if (installmentTableHeading) {
		installmentTableHeading.addEventListener("click", () => {
			installmentTableHeading.parentElement.classList.toggle("open");
		});
	}
}

slideToggleInstallmentTable();


/* LEGENDAS VARIANTES ATIVAS */
function activeVariantLabels() {
    document.addEventListener("click", (event) => {
        const item = event.target.closest("variant-radios .product-form__input > label");
        if (item) {
            const getVal = item.getAttribute("data-value");
            const optionSelectedValue = item.parentElement.querySelector(".option-selected-value");
            if (optionSelectedValue) {
                optionSelectedValue.innerText = getVal;
            }
        }
    });
}
activeVariantLabels();



// ALTERA A DIREÇÃO DOS SUBMENUS SE ULTRAPASSAR A VIEWPORT
// =============================================================================================
function checkSubmenuOverflow() {
    document.querySelectorAll('.header__nav-items--dropdown > li').forEach(parentLi => {
        const submenus = parentLi.querySelectorAll('.header__subnav-items--level-1, .header__subnav-items--level-2');
        
        parentLi.classList.remove('submenu--shift-left'); // Remove a classe antes de verificar
        
        submenus.forEach(submenu => {
            const rect = submenu.getBoundingClientRect();
            if (rect.right > window.innerWidth) {
                parentLi.classList.add('submenu--shift-left');
            }
        });
    });
}

// Executa no carregamento da página e no redimensionamento da janela
window.addEventListener('load', checkSubmenuOverflow);
window.addEventListener('resize', checkSubmenuOverflow);



// BLOQUEIO ANTI CÓPIAS
// =============================================================================================
function blockAntiCopy() {
  const body = document.body;

  if (body.dataset.antiCopy === "true") {
    // Block context menu (right click)
    document.addEventListener("contextmenu", e => e.preventDefault());

    // Block keyboard shortcuts
    document.addEventListener("keydown", e => {
      // F12
      if (e.key === "F12") e.preventDefault();

      // Ctrl+Shift+I
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") e.preventDefault();

      // Ctrl+U
      if (e.ctrlKey && e.key.toLowerCase() === "u") e.preventDefault();

      // Ctrl+C (optional, if you also want to block copy)
      if (e.ctrlKey && e.key.toLowerCase() === "c") e.preventDefault();
    });
  }
}
blockAntiCopy();



// VARIANTES DE CORES NA LISTA DE PRODUTOS
// =========================================================================================================
function initProductItemColorSwatch() {
  // Seleciona todos os elementos com a classe 'grid__item'
  const productItems = document.querySelectorAll('.grid__item');

  productItems.forEach(function(element) {
    // Função para recalcular os swatches quando a janela for redimensionada
    function recalculateSwatches() {
      const swatchLists = element.querySelectorAll('.card__color-swatch-list');
      swatchLists.forEach(function(swatchList) {
        const currentWidth = swatchList.clientWidth;
        const maxAllowedWidth = Math.min(currentWidth, 200);
        const maxFit = Math.floor(maxAllowedWidth / 30);
        const colorSwatches = swatchList.querySelectorAll('.card__color-swatch');
        
        colorSwatches.forEach(function(swatch, index) {
          swatch.classList.remove('card__color-swatch--view-more');
          if (index + 1 === maxFit && maxFit !== colorSwatches.length) {
            swatch.classList.add('card__color-swatch--view-more');
          }
        });
      });
    }

    // Função para lidar com a troca de cores
    function colorChanged(target) {
      
      const productItem = target.closest('.grid__item');
      const variantUrl = target.getAttribute('data-variant-url');
      
      productItem.querySelector('.card__heading a').setAttribute('href', variantUrl);
      
      const originalImageElement = productItem.querySelector('.card__media img');
      if (target.hasAttribute('data-image-url') && target.getAttribute('data-media-id') !== originalImageElement.getAttribute('data-media-id')) {
        const newImageElement = document.createElement('img');
        const imgSrcSet = target.getAttribute('data-image-url-150') + " 150w" + target.getAttribute('data-image-url') + " 300w"
        newImageElement.setAttribute('data-expand', "-10");
        newImageElement.classList.add("lazyload");
        newImageElement.setAttribute('data-media-id', target.getAttribute('data-media-id'));
        newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
        newImageElement.setAttribute('data-srcset', `${imgSrcSet}`);
        newImageElement.setAttribute('sizes', "(min-width: 768px) 300px, 150px");
        
        originalImageElement.replaceWith(newImageElement);

      }
    }

    // Adiciona eventos de listener
    element.addEventListener('change', function(event) {
      if (event.target.classList.contains('card__color-swatch-radio')) {
        colorChanged(event.target);
      }
    });

    // Recalcula os swatches quando a janela for redimensionada
    window.addEventListener('resize', recalculateSwatches);

    // Recalcula os swatches na inicialização
    recalculateSwatches();
  });
}

// Chama a função para inicializar
initProductItemColorSwatch();



// BOTÃO COMPRAR PELO WHATSAPP - LISTA
// =============================================================================================
function buyWithWhatsAppList() {

  const btn = document.querySelectorAll(".card .whatsapp-button")
  
  if (btn.length) {

    btn.forEach(item => {

      const btnAnchor = item.children[0]
      const btnHref = btnAnchor.href
      
      function buildCompleteUrl() {
        
        const productUrl = item.hasAttribute("data-show-url") ? `%0A%0A*Link:*%20${window.location.href}` : ""
  
        let productName;
        if (item.hasAttribute("data-show-name") && item.closest(".card").querySelector(".card__heading")){
          productName = `%0A%0A*Nome%20do%20produto:*%20${item.closest(".card").querySelector(".card__heading").innerText}`
        }
        
        let productPrice;
        if (item.hasAttribute("data-show-price") && item.closest(".card").querySelector(".price-item--last")) {
          productPrice = `%0A%0A*Preço:*%20${item.closest(".card").querySelector(".price-item--last").innerText}`
        }
        btnAnchor.href = `${btnHref}${productName ? productName : ""}${productUrl ? productUrl : ""}${productPrice ? productPrice : ""}`  
      }
      buildCompleteUrl()

    })
    
  }
  
}
buyWithWhatsAppList()



// BOTÃO COMPRAR PELO WHATSAPP - PÁGINA DO PRODUTO
// =============================================================================================
function btnBuyWithWhatsAppProduct() {

  if (document.body.classList.contains("template-product")) {
    
    const btn = document.querySelector(".product__info-container .whatsapp-button")

    if (btn) {

      const btnAnchor = btn.children[0]
      const btnHref = btnAnchor.href
      
      function buildCompleteUrl() {
        
        const productUrl = btn.hasAttribute("data-show-url") ? `%0A%0A*Link:*%20${window.location.href}` : ""
  
        let productName;
        if (btn.hasAttribute("data-show-name") && document.querySelector(".product__info-container .product__title")){
          productName = `%0A%0A*Nome%20do%20produto:*%20${document.querySelector(".product__info-wrapper .product__title").innerText}`
        }
        
        let productPrice;
        if (btn.hasAttribute("data-show-price") && document.querySelector(".product__info-container .price__sale .price-item--last")) {
          productPrice = `%0A%0A*Preço:*%20${document.querySelector(".product__info-container .price__sale .price-item--last").innerText}`
        }
        btnAnchor.href = `${btnHref}${productName ? productName : ""}${productUrl ? productUrl : ""}${productPrice ? productPrice : ""}`  
      }
      buildCompleteUrl()
      
      const targetNode = document.querySelector('.product__info-container > [id^="price-template--"]')

      if (targetNode) {
        const config = { attributes: true, childList: true, subtree: true };
        
        const callback = function(mutationsList, observer) {
            for(const mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                  btn.children[0].href = ""
                  buildCompleteUrl()
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);  
      }
            
    }  
    
  }
  
}
btnBuyWithWhatsAppProduct()



// CRONOMETRO DE OFERTA
// =============================================================================================

function initCourtdown() {
  function startCountdown(element) {
    
    const expiryTime = Date.parse(element.getAttribute('data-expiry-time'));
    const daysSpan = element.querySelector('[data-days]');
    const hoursSpan = element.querySelector('[data-hours]');
    const minutesSpan = element.querySelector('[data-minutes]');
    const secondsSpan = element.querySelector('[data-seconds]');

    function updateTimer() {
      const now = Date.now();
      const timeRemaining = expiryTime - now;

      if (timeRemaining <= 0) {
        daysSpan.textContent = '00';
        hoursSpan.textContent = '00';
        minutesSpan.textContent = '00';
        secondsSpan.textContent = '00';
        return; 
      }

      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      daysSpan.textContent = String(days).padStart(2, '0');
      hoursSpan.textContent = String(hours).padStart(2, '0');
      minutesSpan.textContent = String(minutes).padStart(2, '0');
      secondsSpan.textContent = String(seconds).padStart(2, '0');
    }

    setInterval(updateTimer, 1000);
  }

  document.querySelectorAll('.countdown').forEach(startCountdown);

}
initCourtdown()                          



// BUSCA
// =============================================================================================
function search() {
    document.querySelectorAll("[data-search]").forEach(item => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector("header").classList.toggle("header--show-search");
        });
    });

    document.querySelectorAll(".modal-overlay, .search-modal__close-button").forEach(item => {
        item.addEventListener("click", () => {
            document.querySelector("header").classList.remove("header--show-search");
        });
    });
}
search();



// HEADER TRANSPARENTE
// =============================================================================================
function transparentHeader() {
  const header = document.querySelector(".template-index .header");
  if (!header) return; // segurança caso o elemento não exista

  const transparentClass = "header--transparent";

  // só executa se o header tiver a classe header--transparent
  if (!header.classList.contains(transparentClass)) return;

  // Função para atualizar o estado da classe com base na rolagem
  const updateOnScroll = () => {
    if (window.scrollY > 0) {
      header.classList.remove(transparentClass);
    } else {
      header.classList.add(transparentClass);
    }
  };

  // Funções para hover
  const handleMouseEnter = () => {
    header.classList.remove(transparentClass);
  };

  const handleMouseLeave = () => {
    // Só adiciona de volta se o scroll estiver no topo
    if (window.scrollY === 0) {
      header.classList.add(transparentClass);
    }
  };

  // Eventos
  window.addEventListener("scroll", updateOnScroll);
  header.addEventListener("mouseenter", handleMouseEnter);
  header.addEventListener("mouseleave", handleMouseLeave);

  // Inicializar estado correto ao carregar a página
  updateOnScroll();
}

// Chamar a função quando o DOM estiver pronto
transparentHeader();



// VARIÁVEIS DE ALTURA
// =============================================================================================
function initDynamicHeightVariables() {
  const stickyCart = document.querySelector(".productView-stickyCart");
  const cookieNotice = document.querySelector("#notice-cookie-block");

  // Cria o elemento <style> para inserir o CSS dinâmico
  const styleTag = document.createElement("style");
  styleTag.setAttribute("id", "dynamic-heights-style");
  document.head.appendChild(styleTag);

  function updateHeightVars() {
    const stickyHeight = stickyCart ? stickyCart.offsetHeight : 0;
    const cookieHeight = cookieNotice ? cookieNotice.offsetHeight : 0;

    styleTag.innerHTML = `
      :root {
        --stickyCartHeight: ${stickyHeight}px;
        --cookieNoticeHeight: ${cookieHeight}px;
      }
    `;
  }

  // Atualiza na inicialização
  updateHeightVars();

  // Atualiza no resize da janela
  window.addEventListener("resize", updateHeightVars);

  // Observa alterações dinâmicas
  if (stickyCart) {
    const stickyObserver = new ResizeObserver(updateHeightVars);
    stickyObserver.observe(stickyCart);
  }

  if (cookieNotice) {
    const cookieObserver = new ResizeObserver(updateHeightVars);
    cookieObserver.observe(cookieNotice);
  }
}
initDynamicHeightVariables();



// CAMPOS PERSONALIZADOS - CAMPO TIPO FILE 
// =====================================================================================================
function initCustomFileLabels() {
  document.querySelectorAll(".product__custom-field--file input[type='file']").forEach(fileInput => {
    const label = fileInput.closest(".product__custom-field--file").querySelector("label");

    const updateLabel = () => {
      const rawValue = fileInput.value;

      if (rawValue) {
        const fileName = rawValue.split("\\").pop(); // extrai o nome
        label.style.setProperty("--file-name", `"${fileName}"`);
      } else {
        label.style.removeProperty("--file-name");
      }
    };

    // Atualiza quando o usuário escolhe um arquivo
    fileInput.addEventListener("change", updateLabel);
  });
}
initCustomFileLabels();



// CAMPOS PERSONALIZADOS - CAMPO TIPO COR
// =====================================================================================================
function captureDefaultColorValues() {
  document
    .querySelectorAll('[data-custom-field][type="color"]')
    .forEach(field => {
      if (!field.hasAttribute('data-default-value')) {
        field.setAttribute('data-default-value', field.value);
      }
    });
}
captureDefaultColorValues();



// CAMPOS PERSONALIZADOS - CAMPO TIPO FILE (Reconstrução do Campo)
// =====================================================================================================
function restoreFileLabelsOnReturn() {
  document.querySelectorAll(".product__custom-field--file input[type='file']").forEach(fileInput => {
    const label = fileInput.closest(".product__custom-field--file").querySelector("label");

    const rawValue = fileInput.value; // ainda contém C:\fakepath\arquivo.png

    if (rawValue) {
      const fileName = rawValue.split("\\").pop();

      label.style.setProperty("--file-name", `"${fileName}"`);
    } else {
      label.style.removeProperty("--file-name");
    }
  });
}



// CAMPOS PERSONALIZADOS - VALIDAÇÃO CAMPO TIPO NÚMERO
// =====================================================================================================
function initNumberFieldValidation() {
  const customFieldGroups = document.querySelectorAll(".product__custom-fields");

  customFieldGroups.forEach(group => {
    const numberInputs = group.querySelectorAll('input[type="number"]');

    numberInputs.forEach(input => {

      // BLOQUEIA DIGITAÇÃO INVÁLIDA
      input.addEventListener('keydown', e => {
        const allowedKeys = [
          'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
        ];

        if (allowedKeys.includes(e.key)) return;

        // permite números
        if (/^\d$/.test(e.key)) return;

        // bloqueia tudo o resto
        e.preventDefault();
      });

      // BLOQUEIA COLAR TEXTO
      input.addEventListener('paste', e => {
        if (!/^\d+$/.test(e.clipboardData.getData('text'))) {
          e.preventDefault();
        }
      });

    });
  });
}
initNumberFieldValidation();




// CAMPOS PERSONALIZADOS - CONSTRUÇÃO DOS INPUT HIDDEN
// =====================================================================================================
function initCustomHiddenFields() {
  const productForms = document.querySelectorAll('product-form form[action="/cart/add"]');
  if (!productForms.length) return;

  const customFieldGroups = document.querySelectorAll('.product__custom-fields');

  productForms.forEach(productForm => {
    customFieldGroups.forEach(group => {
      const fields = group.querySelectorAll('[data-custom-field]');

      const radioGroups = {}; // armazena hidden por grupo de radio

      fields.forEach(field => {
        const fieldName = field.getAttribute('name');
        if (!fieldName) return;

        // Detecta radio
        if (field.type === 'radio') {
          // Se ainda não criamos o hidden para este grupo, criamos
          if (!radioGroups[fieldName]) {

            // Se já existe um hidden para este grupo, usa ele
            let hiddenInput = productForm.querySelector(`input[type="hidden"][name="${fieldName}"]`);

            if (!hiddenInput) {
                hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = fieldName;
                hiddenInput.value = "";
                hiddenInput.setAttribute('data-custom-properties', '');
                productForm.appendChild(hiddenInput);
            }


            // Função para atualizar data-required-hidden dinamicamente
            const updateRequiredHidden = () => {
              if (field.closest(`[name="${fieldName}"]`).hasAttribute('data-required')) {
                hiddenInput.setAttribute('data-required-hidden', '');
              } else {
                hiddenInput.removeAttribute('data-required-hidden');
              }
            };
            updateRequiredHidden();

            const fieldObserver = new MutationObserver(updateRequiredHidden);
            // Observa todos os radios do grupo
            const radioGroup = document.querySelectorAll(`[name="${fieldName}"]`);
            radioGroup.forEach(radio => {
              fieldObserver.observe(radio, { attributes: true, attributeFilter: ['data-required'] });
            });

            // Atualiza hidden quando o usuário muda a seleção
            radioGroup.forEach(radio => {
              radio.addEventListener('change', () => {
                const checkedRadio = document.querySelector(`[name="${fieldName}"]:checked`);
                hiddenInput.value = checkedRadio ? checkedRadio.value : '';

                // Remove erro do grupo de radio corretamente
                const parentField = radio.closest('.product__custom-field'); // usa o radio, não o hidden
                if (parentField && hiddenInput.value) {
                  parentField.classList.remove('product__custom-field--error');
                }
              });
            });

            radioGroups[fieldName] = hiddenInput;
          }

        } else {

          // Campos normais continuam exatamente como você escreveu
          let hiddenInput = productForm.querySelector(`input[type="hidden"][name="${fieldName}"]`);
          if (!hiddenInput) {
            hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = fieldName;
            hiddenInput.value = "";
            hiddenInput.setAttribute('data-custom-properties', '');
            productForm.appendChild(hiddenInput);
          }


          // Função para atualizar data-required-hidden dinamicamente
          const updateRequiredHidden = () => {
            if (field.hasAttribute('data-required')) {
              hiddenInput.setAttribute('data-required-hidden', '');
            } else {
              hiddenInput.removeAttribute('data-required-hidden');
            }
          };

          // Checagem inicial
          updateRequiredHidden();

          // Observa mudanças no atributo data-required do campo
          const fieldObserver = new MutationObserver(updateRequiredHidden);
          fieldObserver.observe(field, { attributes: true, attributeFilter: ['data-required'] });

          // Atualiza o hidden quando o usuário digitar/mudar algo
          const updateHidden = () => {
            if (!field.disabled) {
              const value = getFieldValue(field);
              hiddenInput.value = value;

              // Intercepta e remove classe de erro do pai se houver valor
              const parentField = field.closest('.product__custom-field');
              if (parentField && value) {
                parentField.classList.remove('product__custom-field--error');
              }
            }
          };


          field.addEventListener('input', (e) => {

            const field1 = e.target;
            if (field1.matches('[data-custom-field][type="color"]')) {
              field1.setAttribute('data-user-touched', 'true');
            }

            updateHidden();

          });

          field.addEventListener('input', updateHidden);
          field.addEventListener('change', updateHidden);
        }

        // Observa quando o bloco variante recebe ou remove data-hidden
        const variantBlock = field.closest('[data-variant-block]');
        if (variantBlock) {

          const observer = new MutationObserver(() => {
            const isHidden = variantBlock.hasAttribute('data-hidden');

            if (isHidden) {
            // RESET GERAL

                if (field.type === 'file') {
                  const label = field.previousElementSibling;
                  if (label) {
                    label.removeAttribute('style');
                  }
                }

                if (field.type === 'checkbox') {
                    // Corrigido: não apaga o value
                    field.checked = false;

                    const hiddenInput = productForm.querySelector(`input[type="hidden"][name="${fieldName}"]`);
                    if (hiddenInput) hiddenInput.value = "";

                }

                if (field.type === 'radio' || field.type === 'checkbox') {
                    // Corrigido: não apaga o value
                    field.checked = false;

                    const hiddenInput = radioGroups[fieldName];
                    if (hiddenInput) hiddenInput.value = "";

                } else {
                    // Campos normais
                    field.value = "";
                    const hiddenInput = productForm.querySelector(`input[type="hidden"][name="${fieldName}"]`);
                    if (hiddenInput) hiddenInput.value = "";
                }

                } else {
                // AO EXIBIR
                if (field.type !== 'radio') {
                    const hiddenInput = productForm.querySelector(`input[type="hidden"][name="${fieldName}"]`);
                    if (hiddenInput) hiddenInput.value = "";
                } else {
                    const hiddenInput = radioGroups[fieldName];
                    if (hiddenInput) hiddenInput.value = "";
                }
            }
        });


          observer.observe(variantBlock, { attributes: true, attributeFilter: ['data-hidden'] });
        }

      });
    });
  });

  function getFieldValue(field) {
    if (field.type === 'checkbox') return field.checked ? (field.value || 'on') : '';
    if (field.type === 'radio') return field.checked ? field.value : '';
    if (field.tagName === 'SELECT')
      return field.options[field.selectedIndex]?.value || '';
    return field.value || '';
  }
}
initCustomHiddenFields();



// NAVEGAÇÃO BOTÕES VOLTAR/AVANÇAR DO BROWSER) 
// =====================================================================================================
function isBackForwardNavigation() {
  const nav = performance.getEntriesByType("navigation")[0];
  return nav && nav.type === "back_forward";

  // Fallback legado (Safari antigo)
  return performance.navigation &&
         performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD;

}



// CAMPOS PERSONALIZADOS - REINSERÇÃO DOS VALORES NOS INPUT HIDDEN (Botões Voltar/Avançar do Browser) 
// =====================================================================================================
function syncCustomHiddenFields() {

  const productForms = document.querySelectorAll(
    'product-form form[action="/cart/add"]'
  );

  productForms.forEach(productForm => {
    const fields = document.querySelectorAll('[data-custom-field]');

    fields.forEach(field => {
      const fieldName = field.getAttribute('name');
      if (!fieldName) return;

      const hiddenInput = productForm.querySelector(
        `input[type="hidden"][name="${fieldName}"]`
      );
      if (!hiddenInput) return;

      // 🎨 COLOR — lógica correta
      if (field.type === 'color') {
        const defaultValue = field.getAttribute('data-default-value');
        const wasTouched =
          field.hasAttribute('data-user-touched') ||
          field.value !== defaultValue;

        if (!wasTouched) return;
      }

      let value = '';

      if (field.type === 'radio') {
        const checked = document.querySelector(
          `[name="${fieldName}"]:checked`
        );
        value = checked ? checked.value : '';

      } else if (field.type === 'checkbox') {
        value = field.checked ? (field.value || 'on') : '';

      } else if (field.tagName === 'SELECT') {
        value = field.options[field.selectedIndex]?.value || '';

      } else {
        value = field.value || '';
      }

      hiddenInput.value = value;
    });
  });
}



// VALIDAÇÃO CAMPOS PERSONALIZADOS - BOTÃO DIRETO PARA O CHECKOUT
// =============================================================================================
function initShopifyPaymentButtonValidation() {

  document.addEventListener("click", function (e) {

    const botao = e.target.closest('[data-shopify="payment-button"] button');
    if (!botao) return;

    const wrapper = botao.closest('[data-shopify="payment-button"]');
    if (!wrapper) return;

    const form = wrapper.closest("form");
    
    if (!form) return;

    // ----------------------------------------------------------
    // Validar inputs hidden com data-required-hidden
    // ----------------------------------------------------------
    const requiredHidden = form.querySelectorAll(
      'input[type="hidden"][data-required-hidden]'
    );

    const allValidHidden = [...requiredHidden].every(
      i => i.value && i.value.trim() !== ""
    );

    // ----------------------------------------------------------
    // Validar campos customizados obrigatórios (limitado ao form)
    // ----------------------------------------------------------
    const customFields = document.querySelectorAll(
      '.product__custom-fields [data-custom-field][data-required]'
    );

    let allCustomValid = true;
    let firstInvalidField = null;

    customFields.forEach(field => {

      const parent = field.closest('.product__custom-field');
      let isValid = true;

      const type = field.type;
      const tag = field.tagName.toLowerCase();

      // COLOR PICKER
      if (type === "color") {
        if (!field.value || field.value === "#000000") {
          isValid = false;
        }
      }

      // CHECKBOX
      else if (type === "checkbox") {
        if (!field.checked) {
          isValid = false;
        }
      }

      // RADIO
      else if (type === "radio") {
        const group = document.querySelectorAll(
          `.product__custom-fields input[type="radio"][name="${field.name}"]`
        );

        const oneChecked = [...group].some(r => r.checked);

        if (!oneChecked) {
          isValid = false;

          if (!firstInvalidField) {
            firstInvalidField = field;
          }
        }
      }

      // SELECT
      else if (tag === "select") {
        if (!field.value || field.value.trim() === "") {
          isValid = false;
        }
      }

      // CAMPOS NORMAIS
      else {
        if (!field.value || field.value.trim() === "") {
          isValid = false;
        }
      }

      // Aplicar classes + armazenar o primeiro inválido
      if (!isValid) {
        allCustomValid = false;

        if (parent) {
          parent.classList.add('product__custom-field--error');
        }

        if (!firstInvalidField && type !== "radio") {
          firstInvalidField = field;
        }

      } else {
        if (parent) {
          parent.classList.remove('product__custom-field--error');
        }
      }

    });

    // Scroll + foco
    if (firstInvalidField) {
      firstInvalidField.focus({ preventScroll: true });
      firstInvalidField.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }

    // ----------------------------------------------------------
    // Bloquear clique se inválido
    // ----------------------------------------------------------
    if (!allValidHidden || !allCustomValid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    // ----------------------------------------------------------
    // Tudo OK → Shopify segue fluxo normal
    // ----------------------------------------------------------
    console.log("✔ Fluxo liberado (todas validações OK).");

  }, true); // capture = true (antes do Shopify)

}
initShopifyPaymentButtonValidation();





// CHAMADA DE FUNÇÕES PARA O COMPORTAMENTO DOS BOTÕES VOLTAR/AVANÇAR DO BROWSER
// =============================================================================================
window.addEventListener("pageshow", () => {
  restoreFileLabelsOnReturn();
  syncCustomHiddenFields();
});




// MENU INTELIGENTE
// =============================================================================================
function setupSmartMenu() {

      let resizeTimer;
      let menu = document.querySelector(".header__nav-row");

      function hideMenu() {
          if (!menu) return;
          menu.classList.remove("processed");
      }

      function showMenu() {
          if (!menu) return;
          menu.classList.add("processed");
      }

      // MENU INTELIGENTE
      function smartMenu() {
          
          const menuContainer = document.querySelector("[data-smart-menu]");
          
          if (menuContainer) {

            hideMenu();

                        
              // VARIAVEIS GLOBAIS DA FUNCAO
              const menu = menuContainer.querySelector(".header__nav-row");
              const menuNavigation = menuContainer.querySelector(".header__nav-items");
              const menuItems = menuNavigation.querySelectorAll(".level-top");
              const moreCateg = menuNavigation.querySelector(".header__nav-more");
              const moreCategInner = moreCateg.querySelector(":scope > .header__nav-items--dropdown") || moreCateg.querySelector(".header__subnav-items-wrapper");
              const navVerticalWidth = document.querySelector(".header__nav-vertical") ? document.querySelector(".header__nav-vertical").offsetWidth : 0;
              const desktopWindowWidth = window.matchMedia("(min-width: 992px)");

              // FUNCAO INICIA O SMART MENU
              function initSmartMenu() {

                  
                  let menuWidth = menu.offsetWidth;
                  
                  function categsFlow() {

                      function normalizeMenu() {
                              
                        const menuItems3 = menuNavigation.querySelectorAll(".header__nav-main > .header__nav-items > li");
                        
                        let categsTotalWidth3 = 0;
                        for(let i = 0; i < menuItems3.length; i++){
                            categsTotalWidth3 += menuItems3[i].offsetWidth;
                        } 

                        if ((categsTotalWidth3 + navVerticalWidth) <= menuWidth) {
                          destroySmartMenu()
                        }
                      }
                      normalizeMenu();

                  
                      function firstCategsTotalWidthCheck() {
                          
                          let categsTotalWidth = 0;
                          for(let i = 0; i < menuItems.length; i++){
                              
                              categsTotalWidth += menuItems[i].offsetWidth;

                              if((categsTotalWidth + navVerticalWidth) >= menuWidth){
                                  break;
                              } 

                              menuItems[i].classList.add("visible");
             
                          } 
                          
                      }

                      firstCategsTotalWidthCheck();
                      
                      const categNotVisible = document.querySelectorAll(".header__nav-main .header__nav-items > .level-top:not(.visible)");

                      if(categNotVisible.length){
                          const fragment = document.createDocumentFragment();
                          categNotVisible.forEach(item => {
                              item.querySelector(".header__nav-item").classList.remove("header__nav-item--level-top");
                              fragment.appendChild(item); // mantém a ordem original
                          });
                          moreCategInner.prepend(fragment);
                      }
                      
                      menuItems.forEach(item => { item.classList.remove("visible"); });
                      
                      const lastCateg = document.querySelector(".header__nav-main .header__nav-items > .level-top:nth-last-child(-n+2):first-child:not(:only-child)");

                      if(lastCateg){
                          const lastCategWidth = moreCateg.previousElementSibling.offsetWidth;
                          const moreCategWidth = moreCateg.offsetWidth;
                          if((lastCategWidth + moreCategWidth + navVerticalWidth) > menuWidth){
                              moreCategInner.prepend(moreCateg.previousElementSibling);
                          }
                      } 

                      
                      if((menuNavigation.offsetWidth + navVerticalWidth) > menuWidth && moreCateg.previousElementSibling) {
                          moreCateg.previousElementSibling.querySelector(".header__nav-item").classList.remove("header__nav-item--level-top");
                          moreCategInner.prepend(moreCateg.previousElementSibling);
                      }
                      
                      const moreCategLi = document.querySelector(".header__nav-more .level-top");
                      
                      if(moreCategLi){
                          
                          moreCateg.classList.remove("d-none");
                          menuNavigation.prepend(moreCateg);
      
                          function secondCategsTotalWidthCheck() {
                              
                              const menuItems2 = menuNavigation.querySelectorAll(".header__nav-main > .header__nav-items > li");
                              
                              let categsTotalWidth2 = 0;
                              for(let i = 0; i < menuItems2.length; i++){
                                  
                                  categsTotalWidth2 += menuItems2[i].offsetWidth;

                                  if((categsTotalWidth2 + navVerticalWidth) >= menuWidth){
                                      break;
                                  }
                                  
                                   menuItems2[i].classList.add("visible");                                  
                                  
                              } 
      
                          }
                          secondCategsTotalWidthCheck();
                          
                          const categNotVisible = document.querySelectorAll(".header__nav-main > .header__nav-items > .level-top:not(.visible)");

                          if(categNotVisible.length){
                              const fragment = document.createDocumentFragment();
                              categNotVisible.forEach(item => {
                                  item.querySelector(".header__nav-item").classList.remove("header__nav-item--level-top");
                                  fragment.appendChild(item); // mantém a ordem original
                              });
                              moreCategInner.prepend(fragment);

                          }
                          menuNavigation.append(moreCateg);
                          
                          menuItems.forEach(item => { item.classList.remove("visible"); });
                          moreCateg.classList.remove("visible");
                          
                          const lastCateg = document.querySelector(".header__nav-main .header__nav-items > .level-top:nth-last-child(-n+2):first-child:not(:only-child)");
                          if(lastCateg){
                              const lastCategWidth = moreCateg.previousElementSibling.offsetWidth;
                              const moreCategWidth = moreCateg.offsetWidth;
                              if(lastCategWidth + moreCategWidth + navVerticalWidth > menuWidth){
                                  moreCategInner.prepend(moreCateg.previousElementSibling);
                              }
                          } 
                          if((menuNavigation.offsetWidth + navVerticalWidth) > menuWidth && moreCateg.previousElementSibling) {
                              moreCateg.previousElementSibling.querySelector(".header__nav-item").classList.remove("header__nav-item--level-top");
                              moreCategInner.prepend(moreCateg.previousElementSibling);
                          }
                                                
                          
                      }
                      
                  }
                  categsFlow();
                  showMenu();
              }
              
              
              // FUNCAO DESFAZ O SMART MENU
              function destroySmartMenu() {
                  const moreCategItems = document.querySelectorAll(".header__nav-more .level-top");
                  if (moreCategItems.length) {
                      const fragment = document.createDocumentFragment();
                      moreCategItems.forEach(item => {
                          item.querySelector(".header__nav-item").classList.add("header__nav-item--level-top");
                          fragment.appendChild(item); // mantém a ordem atual do dropdown
                      });
                      menuNavigation.appendChild(fragment);
                  }

                  moreCateg.classList.add("d-none");
                  menuNavigation.append(moreCateg);
              }            
              
              // FUNCAO QUE CHECA A LARGURA DA VIEWPORT PARA INICIAR OU DESFAZER O SMART MENU
              function checkWindowWidth() {
                  if(desktopWindowWidth.matches){
                      initSmartMenu();
                  } else {
                    destroySmartMenu(); 
                  }
              }
              checkWindowWidth();
              

              // ATIVA A FUNCAO DE CHECAGEM DA VIEWPORT EM NAVEGADORES MODERNOS E ANTIGOS
              try { 
                  desktopWindowWidth.addEventListener("change", checkWindowWidth); 
              } 
              catch (e) {
                  desktopWindowWidth.addListener(checkWindowWidth); 
              }
              
          }
          
      }

      smartMenu();

      window.addEventListener("resize", () => {
      hideMenu();

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
          smartMenu();
      }, 200); // tempo de "parada" do resize
    });

}

setupSmartMenu();



// VARIAVEL DE LARGURA PARA O MENU VERTICAL
// =============================================================================================
function createVerticalMenuWidthVar({
    navRowSelector = '.header__nav > .container',
    navVerticalSelector = '.header__nav-vertical',
    cssVarName = '--vertical-menu-width'
} = {}) {

    const navRow = document.querySelector(navRowSelector);
    const navVertical = document.querySelector(navVerticalSelector);

    if (!navRow || !navVertical) {
        console.warn('Elementos não encontrados.');
        return;
    }

    // Cria o <style> uma única vez
    const style = document.createElement('style');
    document.head.appendChild(style);

    function update() {
        const rowRect = navRow.getBoundingClientRect();
        const verticalRect = navVertical.getBoundingClientRect();

        const distanceFromLeft = verticalRect.left - rowRect.left;
        const width = Math.max(0, rowRect.width - distanceFromLeft);

        style.textContent = `
            :root {
                ${cssVarName}: ${width}px;
            }
        `;
    }

    // Atualiza imediatamente
    update();

    // Observa ambos os elementos
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(navRow);
    resizeObserver.observe(navVertical);

    // Garante atualização quando a viewport mudar
    window.addEventListener('resize', update);

    return {
        update,
        destroy() {
            resizeObserver.disconnect();
            window.removeEventListener('resize', update);
            style.remove();
        }
    };
}

// Inicialização
createVerticalMenuWidthVar();

























